import { cva } from '@/styled-system/css';

import { TIMESLOT_GROUP_MIN_HEIGHT_MINUTES_20_PX, TIMESLOT_GROUP_MIN_HEIGHT_PX } from '../../constants/TourCalendar';

const SHADOW_100 = '0 2px 4px 0 rgba(0, 0, 0, 0.3)';

export const calendarStyles = cva({
  base: {
    overflowY: 'initial !important',

    '& .rbc-today': { backgroundColor: 'initial' },

    '& .rbc-header.rbc-today': {
      backgroundColor:
        'blue.100' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
      borderRadius: '8px',
      marginBottom: 'xs',
    },

    '& .rbc-allday-cell': { display: 'none' },

    '& .rbc-label': {
      color:
        'gray.600' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
      fontSize: '12px',
    },

    '& .rbc-time-view': { border: 'none' },

    '& .rbc-header': {
      borderBottom: 'none',
      borderLeft: 'none',
    },

    '& .rbc-time-header': { borderRight: 'none' },

    '& .rbc-time-header-content': { borderLeft: 'none' },

    // oxlint-disable-next-line constellation/no-raw-spacing-values -- `minWidth: 79px` falls between `1900` (76px) and `2000` (80px) on the numeric sizes scale
    '& .rbc-time-header-gutter': { minWidth: '79px' },

    '& .rbc-time-gutter': {
      // oxlint-disable-next-line constellation/no-raw-spacing-values -- `minWidth: 79px` falls between `1900` (76px) and `2000` (80px) on the numeric sizes scale
      minWidth: '79px',
      textAlign: 'center',
      backgroundColor:
        'gray.50' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
    },

    '& .rbc-timeslot-group': {
      borderBottom: 'none',
      minHeight: `${TIMESLOT_GROUP_MIN_HEIGHT_PX}px`,

      '&.rbc-timeslot-group-minutes_20': {
        minHeight: `${TIMESLOT_GROUP_MIN_HEIGHT_MINUTES_20_PX}px`,
      },
    },

    '& .rbc-day-slot .rbc-time-slot': {
      borderTop: 'none',
      zIndex: 1,

      '&:not(.rbc-slot-past)': {
        marginBlock: '0',
        marginInline: 'default',
        '@media screen and (min-width: 769px)': {
          marginInline: 'tighter',
        },
      },

      '&:hover:not(.rbc-slot-past)': {
        backgroundColor:
          'gray.100' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
        borderRadius: '8px',
        cursor: 'pointer',
      },
    },

    '& .rbc-day-slot .rbc-slot-selection': {
      backgroundColor:
        'gray.300' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
      borderRadius: '8px',
      boxShadow: SHADOW_100,
      width: '92%',
      left: '4%',
    },

    '& .rbc-events-container': {
      marginRight: '0 !important',
    },

    '& .rbc-current-time-indicator': {
      backgroundColor:
        'orange.600' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
      height: '50',
    },

    '& .rbc-time-content': {
      fontFamily: "'Open Sans', 'Adjusted Arial', Tahoma, Geneva, sans-serif",
    },

    '& .rbc-event': {
      border: 'none',
      zIndex: 2,

      '&.rbc-selected': {
        zIndex: 4,
        boxShadow: SHADOW_100,
      },

      '&:hover': {
        zIndex: 4,
        boxShadow: SHADOW_100,
      },

      '&:focus-visible': {
        zIndex: 4,
        boxShadow: SHADOW_100,
      },

      '&.rbc-event-availability-event': {
        backgroundColor: 'purple.100',
        '&.rbc-selected': {
          backgroundColor:
            'purple.500' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
        },
        '&:not(.rbc-selected):hover': {
          backgroundColor:
            'purple.400' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
        },
      },

      '&.rbc-event-tour-event': {
        boxShadow: SHADOW_100,
        backgroundColor:
          'blue.100' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
        '&.rbc-selected': { backgroundColor: 'blue.500' },
        '&:not(.rbc-selected):hover': {
          backgroundColor:
            'blue.200' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
        },

        '&.rbc-event-tour-requested': {
          backgroundColor:
            'gray.100' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
          '&.rbc-selected': {
            backgroundColor:
              'gray.800' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
          },
          '&:not(.rbc-selected):hover': {
            backgroundColor:
              'gray.300' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
          },
        },

        '&.rbc-event-tour-expired': {
          backgroundColor:
            'yellow.200' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
          '&.rbc-selected': {
            backgroundColor:
              'yellow.500' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
          },
          '&:not(.rbc-selected):hover': {
            backgroundColor:
              'yellow.400' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
          },
        },

        '&.rbc-event-tour-cancelled': {
          backgroundColor:
            'red.100' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
          '&.rbc-selected': {
            backgroundColor:
              'red.500' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
          },
          '&:not(.rbc-selected):hover': {
            backgroundColor:
              'red.300' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
          },
        },

        // Sits above the overlapped cancelled tile regardless of render order. This block is more
        // specific than the base `:hover`/`:focus-visible`/`.rbc-selected` rules, so the elevation
        // override is nested here to keep hover/focus/selected lifting this tile to the front.
        '&.rbc-event-tour-overlaps-cancelled': {
          border: '1px solid white',
          zIndex: 3,
          '&:hover, &:focus-visible, &.rbc-selected': {
            zIndex: 4,
          },
        },
      },
    },

    '& .rbc-event .calendar-event-text': {
      color:
        'gray.800' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
    },

    '& .rbc-event.rbc-selected .calendar-event-text': {
      // oxlint-disable-next-line constellation/no-raw-color-values
      color: 'white',
    },

    '& .calendar-event-strikethrough-text': {
      textDecoration: 'line-through',
    },

    '& .rbc-event.rbc-event-past-event': {
      opacity: 0.6,
    },

    '& .rbc-day-slot .rbc-slot-past': {
      backgroundColor:
        'gray.50' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
    },

    '& .rbc-current-time-indicator .time-badge': {
      position: 'relative',
      // oxlint-disable-next-line constellation/no-raw-spacing-values -- `left: -60px` is below the numeric spacing scale, which starts at `25` (1px)
      left: '-60px',
      // oxlint-disable-next-line constellation/no-raw-spacing-values -- `top: -12px` is below the numeric spacing scale, which starts at `25` (1px)
      top: '-12px',
      fontSize: '12px',
      fontWeight: 600,
      backgroundColor:
        'orange.600' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
      padding: '2px 8px',
      borderRadius: '25px',
      display: 'inline-block',
      // oxlint-disable-next-line constellation/no-raw-color-values
      color: 'white',
    },
  },
  variants: {
    mode: {
      tourAvailability: {
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor:
          'gray.200' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
        height: '80vh',
        '@media screen and (max-width: 768px)': {
          borderTop: 'none',
        },
      },
      default: {
        height: '100vh',
      },
    },
  },
});
